import AjaxTable from './AjaxTable';
import parse from 'url-parse';

/**
 * Extend the standard AJAXTable with some extra options to handle search results.
 */
export default class SearchAjaxTable extends AjaxTable {

    /**
     * [constructor description]
     * @param  JQuery   element         Element that contains the table.
     * @param  Object   initialState    Initial Flux State of the table.
     * @param  string   stateVars       List of additional state variables that should be appended to the AJAX request.
     */
    constructor(element, initialState, stateVars) {
        super(element);
        this.initialState = initialState;
        this.stateVars = stateVars;
    }

    /**
     * Initialise the SearchAjaxTable
     * @return void
     */
    init() {
        super.init();
        this.state = Object.assign({}, this.state, this.initialState);
    }

    /**
     * List of state variables to append to the AJAX request.
     * @return string[]
     */
    ajaxStateVars() {
        return super
            .ajaxStateVars()
            .concat(this.stateVars);
    }
}
